import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=73c830ba"
import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"
import style0 from "./messages.vue?vue&type=style&index=0&id=73c830ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports